// src/lang/index.js
import Vue from "vue";
import VueI18n from "vue-i18n";
import zhCN from "./zh-CN";
import enUS from "./en-US";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: localStorage.getItem("language") || "zh-CN", // 优先读取本地存储，默认中文
    messages: {
        "zh-CN": zhCN,
        "en-US": enUS
    }
});

export default i18n;